<template>
	<div class="sideways-page-one">
		<!-- BEGIN PAGE BAR -->
		<div class="page-bar">
			<breadcrumb :crumbs="breadcrumbArray"></breadcrumb>
		</div>
		<!-- <h1 class="page-title">Schedule</h1> -->
		<div v-if="step === 0" class="flex-center" >
			<div>
				<h1> Schedule Manager </h1>
			</div>
			<div>
				<el-button @click="setStep(3), getPresentations(), clear()" style="width:25%" type="primary"> Create a new Schedule</el-button>
				<el-button @click="setStep(2), getSchedules()" style="width:25%" type="primary"> Edit existing Schedule</el-button>
			</div>
		</div>
		<div v-if="step === 3" class="flex-center" >
			<div>
				<h1> Select a Presentation </h1>
			</div>
			<div>
				<template v-for="(pres, index) in presentationList">
					<el-button v-if="flaggedPresentations.indexOf(index) !== -1" @click="selectPres(index)" style="width:25%;" type="primary"> {{ pres.name }} </el-button>
					<el-button v-else="flaggedPresentations.indexOf(index) !== -1" @click="selectPres(index)" style="width:25%" type="default"> {{ pres.name }} </el-button>
					<br>
					<br>
				</template>
			</div>
		</div>
		<div v-if="step === 1" class="flex-center" >
			<div v-if="!edit">
				<h1> Create new Schedule </h1>
				<h3> Selected Presentation: {{ selectedPresentation.name}} </h3>
			</div>
			<div v-else>
				<h1> Edit Schedule </h1>
				<h3> Selected Presentation: {{ selectedPresentation.name}} </h3>
			</div>
			<div>
				<button @click="type = 1, clear()" class="button btn">
					One time
				</button>
				<button @click="type = 2, clear()" class="button btn">
					Recurring/Weekly
				</button>
				<button @click="type = 3, clear()" class="button btn">
					Time Limited/Weekly
				</button>
			</div>
			<div v-if="type === 1">
				<div>
					<el-select v-model="multipleDays" placeholder="Select">
						<el-option
						v-for="(item, i) in days"
						:key="item"
						:label="item"
						:value="i">
						</el-option>
					</el-select>
				</div>
				<div>
					<el-time-picker
						v-model="startTime"
						placeholder="Select Start Time">
					</el-time-picker>
					<el-date-picker
						v-model="dateRange"
						type="datetimerange"
						range-separator=" - "
						placeholder="Select range"
						start-placeholder="Start date"
						end-placeholder="End date">
					</el-date-picker>
				</div>
				<div style="margin-top:20px">
					<el-button @click="addToList({start_time: timeFormat(startTime), presentation_id: selectedPresentation.presentation_id, day_of_week: multipleDays, schedule_type: 'one-time', start_datetime_range : dateFormat(dateRange[0]), end_datetime_range: dateFormat(dateRange[1])})" style="width:8%" type="primary"> Add </el-button>
				</div>
			</div>
			<div v-if="type === 2">
				<div>
					<el-select v-model="multipleDays" placeholder="Select">
						<el-option
						v-for="(item, i) in days"
						:key="item"
						:label="item"
						:value="i">
						</el-option>
					</el-select>
				</div>
				<div>
					<el-time-picker
						v-model="startTime"
						placeholder="Select Start Time">
					</el-time-picker>
				</div>
				<div style="margin-top:20px">
					<el-button @click="addToList({presentation_id: selectedPresentation.presentation_id, schedule_type: 'recurring/weekly', day_of_week : multipleDays, start_time: timeFormat(startTime)})" style="width:8%" type="primary"> Add </el-button>
				</div>
			</div>

			<div v-if="type === 3">
				<div>
					<el-select v-model="multipleDays" placeholder="Select">
						<el-option
						v-for="(item, i) in days"
						:key="item"
						:label="item"
						:value="i">
						</el-option>
					</el-select>
				</div>
				<div>
					<el-time-picker
						v-model="startTime"
						placeholder="Select Start Time">
					</el-time-picker>
					<el-date-picker
						v-model="dateRange"
						type="datetimerange"
						range-separator=" - "
						placeholder="Select range"
						start-placeholder="Start date"
						end-placeholder="End date">
					</el-date-picker>
				</div>
				<div style="margin-top:20px">
					<el-button @click="addToList({start_time: timeFormat(startTime), presentation_id: selectedPresentation.presentation_id, day_of_week: multipleDays, schedule_type: 'one-time', start_datetime_range : dateFormat(dateRange[0]), end_datetime_range: dateFormat(dateRange[1])})" style="width:8%" type="primary"> Add </el-button>
				</div>
			</div>

			<div v-for="(entry, i) in schedule" v-if="entry.presentation_id === selectedPresentation.presentation_id">
				<el-button type="default">
					{{ days[entry.day_of_week] }}, {{ entry.schedule_type}} <template v-if="entry.start_time"> at {{ entry.start_time }} </template> 
					<template v-if="entry.start_datetime_range"> {{ entry.start_datetime_range}} to {{ entry.end_datetime_range}} </template>
				</el-button>
				<el-button @click="schedule.splice(i, 1)" type="danger"> Delete </el-button> 
			</div>
			
			<div>
				<el-button @click="save()" style="width:8%" type="primary"> Save </el-button>
				<el-button @click="setStep(0)" style="width:8%" type="primary"> Cancel </el-button>
			</div>
		</div>
		<div v-if="step === 2" class="flex-center" >
			<div>
				<h1> Select a Schedule </h1>
			</div>
			<div>
				<!-- {{ scheduleList }} -->
				<template v-for="(schedule, index) in scheduleList">
					<el-button @click="setStep(3), getPresentations(), setActiveSchedule(schedule.schedule_id), edit = true" style="width:25%" type="primary"> {{ schedule.schedule_id }} </el-button>
					<el-button @click="deleteSchedule(schedule.schedule_id, index)" type="danger"> Delete </el-button> 
					<br>
					<br>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
	import Breadcrumb from '../../modules/Breadcrumb'
	import Signage from '../../../controllers/Signage'
	import {mapGetters} from 'vuex'

	export default {
		data () {
			return {
				schedule: [],
				startTime: '',
				dateRange: '',
				multipleDays: [],
				days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
				day: '',
				value1: '',
				step: 0,
				note: 'Signage Schedule',
				breadcrumbArray: [
					{name: 'UNOapp Signage', link: false},
					{name: 'Schedule Manager', link: false}
				],
				displayCount: 1,
				scheduleHeight: 1080,
				scheduleWidth: 1920,
				visualHeight: 1080,
				visualWidth: 1920,
				regionList: [],
				dragndrop: [],
				selectedRegion: 0,
				scale: 0.5,
				fullscreen: false,
				beforeFullscreen: null,
				grid: 10,
				miniMap: [],
				scheduleList: [],
				type: 0,
				edit: false,
				name: '',
				padding: 60,
				scheduleId: 0,
				displayNumber: 0,
				deleteRegions: [],
				presentationList: [],
				selectedPresentation: 0,
				selectedScheduleId: 0,
				flaggedPresentations: []
			}
		},
		computed: mapGetters([
			'activeLocationId',
			'activeBusinessId'
		]),
		mounted () {
			window.addEventListener('keyup', this.keypress)
			// this.colorHash()
		},
		methods: {
			clear () {
				this.value1 = ''
				this.multipleDays = []
				this.startTime = ''
				this.dateRange = ''
				this.flaggedPresentations = []
			},
			padZero (val) {
				let a
				if (val < 10) {
					a = '0' + val
				} else {
					a = val
				}
				return a
			},
			timeFormat (date) {
				let utc = this.padZero(date.getHours()) + ':' + this.padZero(date.getMinutes()) + ':' + this.padZero(date.getSeconds())
				return utc
			},
			dateFormat (date) {
				let utc = date.getUTCFullYear() + '-' + this.padZero(date.getUTCMonth()) + '-' + this.padZero(date.getUTCDay()) + ' ' + this.padZero(date.getUTCHours()) + ':' + this.padZero(date.getUTCMinutes()) + ':' + this.padZero(date.getUTCSeconds())
				console.log(utc)
				return utc
			},
			selectPres (i) {
				this.schedule = []
				this.selectedPresentation = this.presentationList[i]
				console.log(this.selectedPresentation)
				if (this.edit === true) {
					this.getScheduleEntries(this.selectedScheduleId)
				}
				this.setStep(1)
			},
			getPresentations () {
				return Signage.getPresentations(this.activeLocationId).then(response => {
					this.presentationList = response.payload.presentations
					console.log(response)
				}).catch(e => {
				})
			},
			setActiveSchedule (i) {
				this.selectedScheduleId = i
				this.getScheduleEntries(i)
			},
			addToList (val) {
				this.schedule.push(val)
			},
			save () {
				if (!this.edit) {
					this.createSchedule()
				} else {
					this.deleteSchedule(this.selectedScheduleId)
				}
			},
			createSchedule () {
				let obj = {
					location_id: this.activeLocationId
				}
				return Signage.createSchedule(obj).then(response => {
					this.schedule.forEach(x => {
						let entryObj = x
						entryObj.schedule_id = response.payload.schedule_id
						this.createScheduleEntry(entryObj)
					})
				}).then(x => {
					this.$notify({
						title: 'Schedule saved',
						message: 'Schedule saved successfully',
						type: 'success'
					})
				}).catch(e => {
				})
			},
			getPresentationById (id) {
				return Signage.getPresentations(this.activeLocationId).then(response => {
					response.payload.presentations.forEach((x, i) => {
						if (x.presentation_id === id) {
							this.flaggedPresentations.push(i)
						}
					})
				}).catch(e => {
				})
			},
			getScheduleEntries (id) {
				return Signage.getScheduleEntries(id).then(response => {
					console.log(response)
					this.getPresentationById(response.payload.entries[0].presentation_id)
					this.schedule = response.payload.entries
				}).catch(e => {
				})
			},
			createScheduleEntry (obj) {
				return Signage.createScheduleEntry(obj).then(response => {
					console.log(response)
				}).catch(e => {
				})
			},
			deleteSchedule (id, index = false) {
				return Signage.deleteSchedule(id).then(response => {
					console.log(response)
					if (index !== false) {
						this.scheduleList.splice(index, 1)
					}
					if (this.edit === true) {
						this.createSchedule()
					}
				}).catch(e => {
				})
			},
			getSchedules () {
				return Signage.getSchedules(this.activeLocationId).then(response => {
					console.log(response)
					this.scheduleList = response.payload.schedules
				}).catch(e => {
				})
			},
			selectRegion (val) {
				this.selectedRegion = val
				for (let i = 0; i < this.regionList.length - 1; i++) {
					if (this.regionList[i].background === 'transparent') {
						this.regionList.splice(i, 1)
						break
					}
				}
			},
			onEnd (e) {
				let arr = Array.from(e.to.children)
				arr.forEach((x, i) => {
					this.regionList[parseInt(x.id.substr(-1))].z = Math.abs(i - (arr.length - 1))
				})
			},
			keypress (e) {
				// if (this.step === 3) {
				//  if (e.key === 'n') {
				//    this.addNewRegion()
				//  } else if (e.key === 'Backspace') {
				//    this.deleteRegion()
				//  }
				// }
			},
			toggle () {
				this.$refs.fs.toggle()
				this.$fs.toggle(this.$el.querySelector('.schedule-editor'), {
					wrap: true,
					background: 'white',
					callback: this.fullscreenChange
				})
			},
			fullscreenChange (fullscreen) {
				console.log(fullscreen)
				this.fullscreen = fullscreen
				if (fullscreen === true && this.beforeFullscreen === null) {
					console.log(this.scale)
					this.beforeFullscreen = this.scale
					this.scale = 1
					console.log(this.beforeFullscreen)
				} else if (fullscreen === false && this.beforeFullscreen !== null) {
					this.scale = this.beforeFullscreen
					this.beforeFullscreen = null
				}
			},
			deleteRegion () {
				console.log(this.selectedRegion)
				console.log(this.regionList)
				if (this.selectedRegion !== null) {
					this.deleteZone(this.regionList[this.selectedRegion].zone_id)
					this.regionList[this.selectedRegion].background = 'transparent'
					// this.regionList.splice(this.selectedRegion, 1)
					// this.regionList = this.regionList.map((x, i) => {
					//  if (i !== this.selectedRegion) {
					//    return x
					//  }
					// })
					let count = this.regionList.reduce((t, x) => {
						if (x.background !== 'transparent') {
							t++
						}
						return t
					}, 0)
					if (count === 0) {
						this.regionList = []
					}
					this.selectedRegion = null
				}
			},
			addNewRegion () {
				this.$prompt('Name this Zone', 'Zone', {
					confirmButtonText: 'OK',
					cancelButtonText: 'Cancel',
					inputErrorMessage: 'Invalid Email'
				}).then(value => {
					this.regionList = this.regionList.map(x => {
						let obj = x
						x.z++
						return obj
					})
					this.updateZones()
					let obj = {
						height: 100,
						width: 100,
						x: 0,
						y: 0,
						z: 1,
						background: 'transparent',
						name: value.value
					}
					this.createZone(obj)
				}).catch(() => {
				})
				// const index = this.regionList.length - 1
				// $('#region-' + index).css('background-color', this.getRandomColor())
			},
			onResize (x, y, width, height, i) {
				this.selectedRegion = i
				let r = this.regionList[i]
				r.x = x
				r.y = y
				r.width = width
				r.height = height
			},
			onDrag (x, y, w, h, i, p) {
				this.selectedRegion = i
				let r = this.regionList[i]
				r.x = x
				r.y = y
			},
			setStep (val, type = 0, i) {
				if (val === 0) {
					this.edit = false
				}
				this.step = val
				this.type = type
			}
		},
		components: {
			Breadcrumb
		}
	}
</script>
<style>
.vdr.active {
	opacity: 1 !important;
}
.hoverDisplay:hover {
	opacity: 0.5;
	cursor:pointer;
}
.fullscreen {
	display: flex;
	justify-content: center;
	align-items: center;
}
.handle-tl {
	left: 0 !important;
	top: 0 !important;
}
.handle-tr {
	top: 0 !important;
	right: 0 !important;
}
.handle-tm {
	top: 0 !important;
}
.handle-bm {
	bottom: 0 !important;
}
.handle-mr {
	right: 0 !important;
}
.handle-ml {
	left: 0 !important;
}
.handle-br {
	bottom: 0 !important;
	right: 0 !important;
}
.handle-bl {
	bottom: 0 !important;
	left: 0 !important;
}
</style>
<style scoped>
.region {
	opacity:0.8;
	justify-content:center;
	display:flex;
	align-items:center;
	text-align:center;
	/*border: 2px dotted grey;*/
/*  background-color:lightgrey;*/
}
#draggable { width: 150px; height: 150px; padding: 0.5em; }
.flex-center {
	width:100%;
	display:flex;
	justify-content:center;
	align-items:center;
	flex-wrap:wrap;
	text-align:center;
}
.flex-center > div {
	width: 100%;
	margin: 5px;
}
.el-button+.el-button {
		margin-left: 0px !important;
}
</style>


// WEBPACK FOOTER //
// Content.vue?5a7e2fd6